export default "__VITE_ASSET__BnEdZrQ8__"